"use client";

import type { ComponentType } from "react";

import OPFilters from "@/components/DeckBuilder/game/onePiece/filters/OPFilters";
import UAFilters from "@/components/DeckBuilder/game/unionArena/filters/UAFilters";
import RBFilters from "@/components/DeckBuilder/game/riftbound/filters/RBFilters";
import type { SupportedGames } from "@/types/game";

/**
 * Filter bars written by hand, per game.
 *
 * These predate the declarative spec (components/DeckBuilder/filters/spec.ts).
 * A game listed here renders its own component; a game that returns a spec from
 * its handler gets a bar built from that instead, and needs no entry.
 *
 * This lives beside the components rather than in games/<game>/config.ts because
 * the game configs are imported by server components, and pulling three client
 * filter bars into that graph would drag them onto the server.
 *
 * Nothing new should be added here -- declare a spec instead.
 */

export interface FilterBarProps {
  filters: any;
  setFilter: (key: any, value: any) => void;
  searchDisplay: string;
  setSearchDisplay: (value: string) => void;
  deckCardsMap: any;
  clearAllFilters: () => void;
}

const LEGACY_FILTER_BARS: Partial<
  Record<SupportedGames, ComponentType<FilterBarProps>>
> = {
  "one-piece": OPFilters,
  "union-arena": UAFilters,
  riftbound: RBFilters,
};

export function getLegacyFilterBar(
  game: SupportedGames,
): ComponentType<FilterBarProps> | undefined {
  return LEGACY_FILTER_BARS[game];
}
